import * as React from 'react';

import ActionButton from 'components/buttons/action-button/ActionButton';
import RichTextEditor from 'components/inputs/rich-text-editor/RichTextEditor';
import { ModalFrame, ModalFrameFooter, ModalFrameInner } from 'components/modal';

import { t } from 'utils/language';

import type { PromiseAction } from 'types';

type Props = {
  title: string,
  text: string,
  onCloseModal: () => PromiseAction | void
};

class RichTextPreviewModal extends React.Component<Props> {
  render() {
    const { title, text, onCloseModal } = this.props;

    return (
      <ModalFrame
        title={title}
      >
        <ModalFrameInner
          narrowContent
        >
          <RichTextEditor
            key={text}
            canEdit={false}
            value={text}
          />
        </ModalFrameInner>
        <ModalFrameFooter>
          <ActionButton
            onClick={onCloseModal}
            data={{ qa: 'rich-text-preview-modal__button-close' }}
          >
            {t('action_button_close')}
          </ActionButton>
        </ModalFrameFooter>
      </ModalFrame>
    );
  }
}

export default RichTextPreviewModal;
